"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'UndergroundToken',
    props: {
        token: {
            type: Object,
            required: true,
        },
        location: {
            type: String,
            required: true,
        },
    },
    computed: {
        wrapper() {
            return 'underground-token-wrapper--' + this.location;
        },
        border() {
            return this.token.active ? 'underground-token-border' : '';
        },
        style() {
            return 'underground-token-style--' + this.location;
        },
        tokenClass() {
            return 'underground-token--' + this.token.token;
        },
        shelter() {
            return this.token.shelter ? 'underground-token-shelter' : '';
        },
    },
});
